import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { CapabilitiesProvider } from './Capabilities';
import { RequireCapability } from './components/RequireCapability';
import { InstanceProvider } from './InstanceName';
import { AuthGuard } from './auth/AuthGuard';
import { Shell } from './components/layout/Shell';
import { LandingRoute } from './pages/LandingRoute';
import { ActivityPage } from './pages/ActivityPage';
import { AgendaPage } from './pages/AgendaPage';
import { BusPage } from './pages/BusPage';
import { FindingsPage } from './pages/FindingsPage';
import { GraphPage } from './pages/GraphPage';
import { LintPage } from './pages/LintPage';
import { LoginPage } from './pages/LoginPage';
import { MemoryPage } from './pages/MemoryPage';
import { PagesPage } from './pages/PagesPage';
import { OverviewPage } from './pages/OverviewPage';
import { ProceduresPage } from './pages/ProceduresPage';
import { TeamPulsePage } from './pages/TeamPulsePage';
import { SessionsPage } from './pages/SessionsPage';
import { SourcesPage } from './pages/SourcesPage';
import { StagePage } from './pages/StagePage';

export function App() {
  return (
    <BrowserRouter>
      <InstanceProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <AuthGuard>
                <CapabilitiesProvider>
                  <Shell />
                </CapabilitiesProvider>
              </AuthGuard>
            }
          >
            <Route index element={<LandingRoute />} />
            <Route
              path="graph"
              element={
                <RequireCapability capability="knowledge.base" title="Knowledge Graph">
                  <GraphPage />
                </RequireCapability>
              }
            />
            <Route
              path="lint"
              element={
                <RequireCapability capability="knowledge.base" title="Health">
                  <LintPage />
                </RequireCapability>
              }
            />
            <Route
              path="findings"
              element={
                <RequireCapability capability="reflection" title="Findings">
                  <FindingsPage />
                </RequireCapability>
              }
            />
            <Route path="sessions" element={<SessionsPage />} />
            <Route path="memory" element={<MemoryPage />} />
            <Route
              path="sources"
              element={
                <RequireCapability capability="knowledge.base" title="Sources">
                  <SourcesPage />
                </RequireCapability>
              }
            />
            <Route
              path="pages"
              element={
                <RequireCapability capability="knowledge.base" title="Pages">
                  <PagesPage />
                </RequireCapability>
              }
            />
            <Route
              path="stage"
              element={
                <RequireCapability capability="knowledge.base" title="Stage">
                  <StagePage />
                </RequireCapability>
              }
            />
            <Route
              path="team"
              element={
                <RequireCapability capability="work.trends" title="Team Pulse">
                  <TeamPulsePage />
                </RequireCapability>
              }
            />
            {/* The three tabs shipped as top-level pages in 0.28–0.30.
                They are sections of Team Pulse again, and these redirects
                keep every link and bookmark from that window working. */}
            <Route
              path="work"
              element={<Navigate to="/team?tab=insights" replace />}
            />
            <Route
              path="workload"
              element={<Navigate to="/team?tab=workload" replace />}
            />
            <Route
              path="people"
              element={<Navigate to="/team?tab=people" replace />}
            />
            <Route path="overview" element={<OverviewPage />} />
            <Route path="activity" element={<ActivityPage />} />
            {/* Ungated, like Overview: `/api/activity` is the core's own
                route (machinai 0.62.0), so no extension can be absent.
                The page itself reports an older core (404) and a role
                below editor (403). */}
            <Route path="agenda" element={<AgendaPage />} />
            <Route path="bus" element={<BusPage />} />
            <Route path="procedures" element={<ProceduresPage />} />
          </Route>
        </Routes>
      </AuthProvider>
      </InstanceProvider>
    </BrowserRouter>
  );
}
